import { render, staticRenderFns } from "./StorageStatus.vue?vue&type=template&id=0fbb299c&"
import script from "./StorageStatus.vue?vue&type=script&lang=js&"
export * from "./StorageStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports